import styled from 'styled-components';
import { cssVars } from '../../../app/styles';
import {
  GANTT_TIMELINE_VERTICAL_PADDING_PX,
  MONTH_CONTENT_BOTTOM_SIDE_BORDER_COLOR,
  MONTH_SEPARATION_PADDING_HALF,
} from '../../constants';

export const DailyCalendarContainer = styled.div`
  background: ${MONTH_CONTENT_BOTTOM_SIDE_BORDER_COLOR};
  display: flex;
  align-items: stretch;
  justify-content: stretch;
`;

export const DailyCalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ numDays }) => numDays}, 1fr);
  grid-auto-rows: 1fr;
  margin: 0 ${MONTH_SEPARATION_PADDING_HALF} 0 ${MONTH_SEPARATION_PADDING_HALF};

  ${({ suppressLeftBorder }) => (!suppressLeftBorder ? '' : 'margin-left: 0')};
  background: #fff;
  row-gap: 10px;
  flex: 1;
  padding-bottom: 24px;
`;

export const DayOfMonthLabelEventContainer = styled.div`
  position: relative;
  background-color: ${cssVars.propertyHistoryColors.swimlaneLabelPaneBg};
  text-align: center;
  padding: ${GANTT_TIMELINE_VERTICAL_PADDING_PX}px 5px;
`;
